import GameObject from '../../../GameObject/GameObject';
import TransformComponent from '../../../Component/Transform';
import { Easing } from '@tweenjs/tween.js';
import AnimationClip from '../AnimationClip';
import { getCardHandler } from '../../Card/CardSystem';
import BaseCardHandler from '../../Card/Handler/BaseCardHandler';
import BaseCard from '../../../Prototype/Level/Card/BaseCard';

export class UndoFold extends AnimationClip {
    public *execute(
        gameObject: BaseCard,
        meta?: any
    ): IterableIterator<number> {
        const transform: TransformComponent = gameObject.getComponent(
            TransformComponent
        );
        const handler: BaseCardHandler = getCardHandler(gameObject);

        const tweenX = this.getTween(transform.position);
        tweenX
            .to(
                {
                    x: -150,
                    y: 0,
                },
                300
            )
            .easing(Easing.Quadratic.InOut)
            .start(this.elapsedTime);

        const tweenIn = this.getTween(transform.scale);
        tweenIn.to({ x: 0 }, 150).easing(Easing.Quadratic.In);

        yield* this.startTween(tweenIn);

        handler.setCardFaceUp(false);

        const tweenOut = this.getTween(transform.scale);
        tweenOut.to({ x: 1 }, 150).easing(Easing.Quadratic.Out);

        // Not yielded...
        yield* this.startTween(tweenOut);

        transform.position.set(-150, 0);
        transform.rotation = 0;
    }
}
